@use '../../style/functions.scss';

:host {
    isolation: isolate;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.5rem 0 0 0;
}

.tag-list {
    position: relative;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    justify-content: center;
    padding: 0.125rem 0.25rem 0.125rem 0.25rem;
    border-radius: 0.25rem;

    &:before,
    &:after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        pointer-events: none;
    }

    &:before {
        border: 1px dotted;
        opacity: 0.4;
    }

    &:after {
        background-color: currentColor;
        opacity: 0.04;
    }

    color: rgb(var(--kompendium-contrast-1100));
}

.tag--private {
    color: rgb(var(--kompendium-color-orange-default));
}

.tag--beta {
    color: rgb(var(--kompendium-color-blue-default));
}

.tag--deprecated {
    color: rgb(var(--kompendium-color-red-default));
}

code {
    font-family: var(--kompendium-font-code);
    font-size: 0.75rem;
}

svg {
    width: 0.75rem;
    opacity: 0.7;
}
